var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1631,
    height: 1357,
    viewBox: "0 0 1631 1357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_2728_79481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350 1006.2L493 682.698H948L1282.5 348.198",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1280.7,
    cy: 350,
    r: 50,
    fill: "url(#paint0_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1278.9,
    cy: 351.802,
    r: 50,
    fill: "url(#paint1_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1277.09,
    cy: 353.604,
    r: 50,
    fill: "url(#paint2_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1275.29,
    cy: 355.405,
    r: 50,
    fill: "url(#paint3_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1273.49,
    cy: 357.208,
    r: 50,
    fill: "url(#paint4_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271.69,
    cy: 359.01,
    r: 50,
    fill: "url(#paint5_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1269.89,
    cy: 360.812,
    r: 50,
    fill: "url(#paint6_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1268.08,
    cy: 362.613,
    r: 50,
    fill: "url(#paint7_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1266.28,
    cy: 364.415,
    r: 50,
    fill: "url(#paint8_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1264.48,
    cy: 366.217,
    r: 50,
    fill: "url(#paint9_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1262.68,
    cy: 368.019,
    r: 50,
    fill: "url(#paint10_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260.88,
    cy: 369.82,
    r: 50,
    fill: "url(#paint11_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1259.08,
    cy: 371.622,
    r: 50,
    fill: "url(#paint12_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1257.27,
    cy: 373.424,
    r: 50,
    fill: "url(#paint13_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1255.47,
    cy: 375.227,
    r: 50,
    fill: "url(#paint14_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1253.67,
    cy: 377.028,
    r: 50,
    fill: "url(#paint15_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1251.87,
    cy: 378.83,
    r: 50,
    fill: "url(#paint16_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1250.07,
    cy: 380.632,
    r: 50,
    fill: "url(#paint17_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1248.26,
    cy: 382.434,
    r: 50,
    fill: "url(#paint18_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1246.46,
    cy: 384.235,
    r: 50,
    fill: "url(#paint19_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1244.66,
    cy: 386.037,
    r: 50,
    fill: "url(#paint20_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1242.86,
    cy: 387.839,
    r: 50,
    fill: "url(#paint21_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.06,
    cy: 389.641,
    r: 50,
    fill: "url(#paint22_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1239.26,
    cy: 391.442,
    r: 50,
    fill: "url(#paint23_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1237.45,
    cy: 393.245,
    r: 50,
    fill: "url(#paint24_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1235.65,
    cy: 395.047,
    r: 50,
    fill: "url(#paint25_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1233.85,
    cy: 396.849,
    r: 50,
    fill: "url(#paint26_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1232.05,
    cy: 398.65,
    r: 50,
    fill: "url(#paint27_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1230.25,
    cy: 400.452,
    r: 50,
    fill: "url(#paint28_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1228.44,
    cy: 402.254,
    r: 50,
    fill: "url(#paint29_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226.64,
    cy: 404.056,
    r: 50,
    fill: "url(#paint30_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1224.84,
    cy: 405.857,
    r: 50,
    fill: "url(#paint31_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1223.04,
    cy: 407.659,
    r: 50,
    fill: "url(#paint32_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1221.24,
    cy: 409.462,
    r: 50,
    fill: "url(#paint33_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1219.44,
    cy: 411.264,
    r: 50,
    fill: "url(#paint34_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1217.63,
    cy: 413.065,
    r: 50,
    fill: "url(#paint35_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215.83,
    cy: 414.867,
    r: 50,
    fill: "url(#paint36_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214.03,
    cy: 416.669,
    r: 50,
    fill: "url(#paint37_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1212.23,
    cy: 418.471,
    r: 50,
    fill: "url(#paint38_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1210.43,
    cy: 420.272,
    r: 50,
    fill: "url(#paint39_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1208.62,
    cy: 422.074,
    r: 50,
    fill: "url(#paint40_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1206.82,
    cy: 423.876,
    r: 50,
    fill: "url(#paint41_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1205.02,
    cy: 425.678,
    r: 50,
    fill: "url(#paint42_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.22,
    cy: 427.48,
    r: 50,
    fill: "url(#paint43_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.42,
    cy: 429.282,
    r: 50,
    fill: "url(#paint44_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1199.62,
    cy: 431.084,
    r: 50,
    fill: "url(#paint45_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1197.81,
    cy: 432.886,
    r: 50,
    fill: "url(#paint46_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1196.01,
    cy: 434.688,
    r: 50,
    fill: "url(#paint47_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194.21,
    cy: 436.489,
    r: 50,
    fill: "url(#paint48_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1192.41,
    cy: 438.291,
    r: 50,
    fill: "url(#paint49_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1190.61,
    cy: 440.093,
    r: 50,
    fill: "url(#paint50_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1188.8,
    cy: 441.895,
    r: 50,
    fill: "url(#paint51_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1187,
    cy: 443.696,
    r: 50,
    fill: "url(#paint52_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1185.2,
    cy: 445.499,
    r: 50,
    fill: "url(#paint53_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1183.4,
    cy: 447.301,
    r: 50,
    fill: "url(#paint54_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181.6,
    cy: 449.103,
    r: 50,
    fill: "url(#paint55_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1179.79,
    cy: 450.904,
    r: 50,
    fill: "url(#paint56_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1177.99,
    cy: 452.706,
    r: 50,
    fill: "url(#paint57_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1176.19,
    cy: 454.508,
    r: 50,
    fill: "url(#paint58_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1174.39,
    cy: 456.31,
    r: 50,
    fill: "url(#paint59_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1172.59,
    cy: 458.111,
    r: 50,
    fill: "url(#paint60_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170.79,
    cy: 459.913,
    r: 50,
    fill: "url(#paint61_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1168.98,
    cy: 461.715,
    r: 50,
    fill: "url(#paint62_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1167.18,
    cy: 463.518,
    r: 50,
    fill: "url(#paint63_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1165.38,
    cy: 465.319,
    r: 50,
    fill: "url(#paint64_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1163.58,
    cy: 467.121,
    r: 50,
    fill: "url(#paint65_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.78,
    cy: 468.923,
    r: 50,
    fill: "url(#paint66_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1159.97,
    cy: 470.725,
    r: 50,
    fill: "url(#paint67_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1158.17,
    cy: 472.526,
    r: 50,
    fill: "url(#paint68_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1156.37,
    cy: 474.328,
    r: 50,
    fill: "url(#paint69_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1154.57,
    cy: 476.13,
    r: 50,
    fill: "url(#paint70_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1152.77,
    cy: 477.932,
    r: 50,
    fill: "url(#paint71_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1150.96,
    cy: 479.734,
    r: 50,
    fill: "url(#paint72_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.16,
    cy: 481.536,
    r: 50,
    fill: "url(#paint73_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1147.36,
    cy: 483.338,
    r: 50,
    fill: "url(#paint74_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1145.56,
    cy: 485.14,
    r: 50,
    fill: "url(#paint75_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1143.76,
    cy: 486.941,
    r: 50,
    fill: "url(#paint76_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1141.96,
    cy: 488.743,
    r: 50,
    fill: "url(#paint77_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1140.15,
    cy: 490.545,
    r: 50,
    fill: "url(#paint78_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.35,
    cy: 492.347,
    r: 50,
    fill: "url(#paint79_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136.55,
    cy: 494.148,
    r: 50,
    fill: "url(#paint80_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1134.75,
    cy: 495.95,
    r: 50,
    fill: "url(#paint81_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1132.95,
    cy: 497.753,
    r: 50,
    fill: "url(#paint82_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1131.14,
    cy: 499.555,
    r: 50,
    fill: "url(#paint83_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1129.34,
    cy: 501.356,
    r: 50,
    fill: "url(#paint84_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.54,
    cy: 503.158,
    r: 50,
    fill: "url(#paint85_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125.74,
    cy: 504.96,
    r: 50,
    fill: "url(#paint86_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1123.94,
    cy: 506.762,
    r: 50,
    fill: "url(#paint87_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1122.13,
    cy: 508.563,
    r: 50,
    fill: "url(#paint88_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120.33,
    cy: 510.365,
    r: 50,
    fill: "url(#paint89_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1118.53,
    cy: 512.167,
    r: 50,
    fill: "url(#paint90_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.73,
    cy: 513.969,
    r: 50,
    fill: "url(#paint91_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.93,
    cy: 515.771,
    r: 50,
    fill: "url(#paint92_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1113.12,
    cy: 517.573,
    r: 50,
    fill: "url(#paint93_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1111.32,
    cy: 519.375,
    r: 50,
    fill: "url(#paint94_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1109.52,
    cy: 521.177,
    r: 50,
    fill: "url(#paint95_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1107.72,
    cy: 522.979,
    r: 50,
    fill: "url(#paint96_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1105.92,
    cy: 524.78,
    r: 50,
    fill: "url(#paint97_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1104.12,
    cy: 526.582,
    r: 50,
    fill: "url(#paint98_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1102.31,
    cy: 528.384,
    r: 50,
    fill: "url(#paint99_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1100.51,
    cy: 530.186,
    r: 50,
    fill: "url(#paint100_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1098.71,
    cy: 531.988,
    r: 50,
    fill: "url(#paint101_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1096.91,
    cy: 533.79,
    r: 50,
    fill: "url(#paint102_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1095.11,
    cy: 535.592,
    r: 50,
    fill: "url(#paint103_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.3,
    cy: 537.394,
    r: 50,
    fill: "url(#paint104_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1091.5,
    cy: 539.195,
    r: 50,
    fill: "url(#paint105_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1089.7,
    cy: 540.997,
    r: 50,
    fill: "url(#paint106_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1087.9,
    cy: 542.799,
    r: 50,
    fill: "url(#paint107_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1086.1,
    cy: 544.601,
    r: 50,
    fill: "url(#paint108_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1084.29,
    cy: 546.402,
    r: 50,
    fill: "url(#paint109_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082.49,
    cy: 548.204,
    r: 50,
    fill: "url(#paint110_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1080.69,
    cy: 550.007,
    r: 50,
    fill: "url(#paint111_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1078.89,
    cy: 551.809,
    r: 50,
    fill: "url(#paint112_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1077.09,
    cy: 553.61,
    r: 50,
    fill: "url(#paint113_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1075.29,
    cy: 555.412,
    r: 50,
    fill: "url(#paint114_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1073.48,
    cy: 557.214,
    r: 50,
    fill: "url(#paint115_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1071.68,
    cy: 559.016,
    r: 50,
    fill: "url(#paint116_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1069.88,
    cy: 560.817,
    r: 50,
    fill: "url(#paint117_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1068.08,
    cy: 562.619,
    r: 50,
    fill: "url(#paint118_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1066.28,
    cy: 564.421,
    r: 50,
    fill: "url(#paint119_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1064.47,
    cy: 566.223,
    r: 50,
    fill: "url(#paint120_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1062.67,
    cy: 568.025,
    r: 50,
    fill: "url(#paint121_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.87,
    cy: 569.827,
    r: 50,
    fill: "url(#paint122_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1059.07,
    cy: 571.629,
    r: 50,
    fill: "url(#paint123_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1057.27,
    cy: 573.431,
    r: 50,
    fill: "url(#paint124_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1055.47,
    cy: 575.232,
    r: 50,
    fill: "url(#paint125_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1053.66,
    cy: 577.034,
    r: 50,
    fill: "url(#paint126_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1051.86,
    cy: 578.836,
    r: 50,
    fill: "url(#paint127_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.06,
    cy: 580.638,
    r: 50,
    fill: "url(#paint128_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.26,
    cy: 582.439,
    r: 50,
    fill: "url(#paint129_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1046.46,
    cy: 584.242,
    r: 50,
    fill: "url(#paint130_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1044.65,
    cy: 586.044,
    r: 50,
    fill: "url(#paint131_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042.85,
    cy: 587.846,
    r: 50,
    fill: "url(#paint132_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1041.05,
    cy: 589.647,
    r: 50,
    fill: "url(#paint133_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.25,
    cy: 591.449,
    r: 50,
    fill: "url(#paint134_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.45,
    cy: 593.251,
    r: 50,
    fill: "url(#paint135_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.65,
    cy: 595.053,
    r: 50,
    fill: "url(#paint136_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1033.84,
    cy: 596.854,
    r: 50,
    fill: "url(#paint137_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1032.04,
    cy: 598.656,
    r: 50,
    fill: "url(#paint138_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1030.24,
    cy: 600.458,
    r: 50,
    fill: "url(#paint139_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.44,
    cy: 602.261,
    r: 50,
    fill: "url(#paint140_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026.64,
    cy: 604.062,
    r: 50,
    fill: "url(#paint141_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024.83,
    cy: 605.864,
    r: 50,
    fill: "url(#paint142_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1023.03,
    cy: 607.666,
    r: 50,
    fill: "url(#paint143_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1021.23,
    cy: 609.468,
    r: 50,
    fill: "url(#paint144_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.43,
    cy: 611.27,
    r: 50,
    fill: "url(#paint145_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1017.63,
    cy: 613.071,
    r: 50,
    fill: "url(#paint146_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1015.82,
    cy: 614.873,
    r: 50,
    fill: "url(#paint147_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1014.02,
    cy: 616.675,
    r: 50,
    fill: "url(#paint148_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012.22,
    cy: 618.477,
    r: 50,
    fill: "url(#paint149_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1010.42,
    cy: 620.279,
    r: 50,
    fill: "url(#paint150_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1008.62,
    cy: 622.081,
    r: 50,
    fill: "url(#paint151_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1006.82,
    cy: 623.883,
    r: 50,
    fill: "url(#paint152_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.01,
    cy: 625.685,
    r: 50,
    fill: "url(#paint153_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1003.21,
    cy: 627.486,
    r: 50,
    fill: "url(#paint154_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1001.41,
    cy: 629.288,
    r: 50,
    fill: "url(#paint155_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 999.608,
    cy: 631.09,
    r: 50,
    fill: "url(#paint156_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 997.807,
    cy: 632.892,
    r: 50,
    fill: "url(#paint157_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996.004,
    cy: 634.693,
    r: 50,
    fill: "url(#paint158_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994.203,
    cy: 636.495,
    r: 50,
    fill: "url(#paint159_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 992.4,
    cy: 638.298,
    r: 50,
    fill: "url(#paint160_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 990.6,
    cy: 640.1,
    r: 50,
    fill: "url(#paint161_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988.797,
    cy: 641.901,
    r: 50,
    fill: "url(#paint162_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 986.995,
    cy: 643.703,
    r: 50,
    fill: "url(#paint163_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 985.193,
    cy: 645.505,
    r: 50,
    fill: "url(#paint164_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 983.392,
    cy: 647.307,
    r: 50,
    fill: "url(#paint165_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 981.59,
    cy: 649.108,
    r: 50,
    fill: "url(#paint166_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 979.787,
    cy: 650.91,
    r: 50,
    fill: "url(#paint167_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 977.986,
    cy: 652.712,
    r: 50,
    fill: "url(#paint168_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.184,
    cy: 654.515,
    r: 50,
    fill: "url(#paint169_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 974.383,
    cy: 656.316,
    r: 50,
    fill: "url(#paint170_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.58,
    cy: 658.118,
    r: 50,
    fill: "url(#paint171_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970.778,
    cy: 659.92,
    r: 50,
    fill: "url(#paint172_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 968.977,
    cy: 661.722,
    r: 50,
    fill: "url(#paint173_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 967.175,
    cy: 663.523,
    r: 50,
    fill: "url(#paint174_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 965.373,
    cy: 665.325,
    r: 50,
    fill: "url(#paint175_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.571,
    cy: 667.127,
    r: 50,
    fill: "url(#paint176_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.77,
    cy: 668.929,
    r: 50,
    fill: "url(#paint177_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 959.967,
    cy: 670.73,
    r: 50,
    fill: "url(#paint178_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958.166,
    cy: 672.533,
    r: 50,
    fill: "url(#paint179_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 956.363,
    cy: 674.335,
    r: 50,
    fill: "url(#paint180_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954.562,
    cy: 676.137,
    r: 50,
    fill: "url(#paint181_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952.76,
    cy: 677.938,
    r: 50,
    fill: "url(#paint182_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950.958,
    cy: 679.74,
    r: 50,
    fill: "url(#paint183_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 949.156,
    cy: 681.542,
    r: 50,
    fill: "url(#paint184_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.087,
    cy: 682.698,
    r: 50,
    fill: "url(#paint185_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 944.539,
    cy: 682.698,
    r: 50,
    fill: "url(#paint186_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.99,
    cy: 682.698,
    r: 50,
    fill: "url(#paint187_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939.442,
    cy: 682.698,
    r: 50,
    fill: "url(#paint188_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.895,
    cy: 682.698,
    r: 50,
    fill: "url(#paint189_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 934.346,
    cy: 682.698,
    r: 50,
    fill: "url(#paint190_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931.797,
    cy: 682.698,
    r: 50,
    fill: "url(#paint191_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.25,
    cy: 682.698,
    r: 50,
    fill: "url(#paint192_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926.701,
    cy: 682.698,
    r: 50,
    fill: "url(#paint193_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 924.152,
    cy: 682.698,
    r: 50,
    fill: "url(#paint194_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 921.605,
    cy: 682.698,
    r: 50,
    fill: "url(#paint195_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 919.057,
    cy: 682.698,
    r: 50,
    fill: "url(#paint196_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916.508,
    cy: 682.698,
    r: 50,
    fill: "url(#paint197_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 913.96,
    cy: 682.698,
    r: 50,
    fill: "url(#paint198_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 911.412,
    cy: 682.698,
    r: 50,
    fill: "url(#paint199_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.863,
    cy: 682.698,
    r: 50,
    fill: "url(#paint200_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.315,
    cy: 682.698,
    r: 50,
    fill: "url(#paint201_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 903.768,
    cy: 682.698,
    r: 50,
    fill: "url(#paint202_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 901.219,
    cy: 682.698,
    r: 50,
    fill: "url(#paint203_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898.671,
    cy: 682.698,
    r: 50,
    fill: "url(#paint204_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 896.123,
    cy: 682.698,
    r: 50,
    fill: "url(#paint205_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.574,
    cy: 682.698,
    r: 50,
    fill: "url(#paint206_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.026,
    cy: 682.698,
    r: 50,
    fill: "url(#paint207_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.479,
    cy: 682.698,
    r: 50,
    fill: "url(#paint208_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 885.93,
    cy: 682.698,
    r: 50,
    fill: "url(#paint209_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.381,
    cy: 682.698,
    r: 50,
    fill: "url(#paint210_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880.834,
    cy: 682.698,
    r: 50,
    fill: "url(#paint211_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.285,
    cy: 682.698,
    r: 50,
    fill: "url(#paint212_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.736,
    cy: 682.698,
    r: 50,
    fill: "url(#paint213_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873.188,
    cy: 682.698,
    r: 50,
    fill: "url(#paint214_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.641,
    cy: 682.698,
    r: 50,
    fill: "url(#paint215_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868.092,
    cy: 682.698,
    r: 50,
    fill: "url(#paint216_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 865.544,
    cy: 682.698,
    r: 50,
    fill: "url(#paint217_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862.996,
    cy: 682.698,
    r: 50,
    fill: "url(#paint218_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 860.447,
    cy: 682.698,
    r: 50,
    fill: "url(#paint219_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 857.899,
    cy: 682.698,
    r: 50,
    fill: "url(#paint220_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855.352,
    cy: 682.698,
    r: 50,
    fill: "url(#paint221_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852.803,
    cy: 682.698,
    r: 50,
    fill: "url(#paint222_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.255,
    cy: 682.698,
    r: 50,
    fill: "url(#paint223_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 847.707,
    cy: 682.698,
    r: 50,
    fill: "url(#paint224_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 845.158,
    cy: 682.698,
    r: 50,
    fill: "url(#paint225_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.61,
    cy: 682.698,
    r: 50,
    fill: "url(#paint226_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840.062,
    cy: 682.698,
    r: 50,
    fill: "url(#paint227_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.514,
    cy: 682.698,
    r: 50,
    fill: "url(#paint228_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834.965,
    cy: 682.698,
    r: 50,
    fill: "url(#paint229_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832.418,
    cy: 682.698,
    r: 50,
    fill: "url(#paint230_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829.869,
    cy: 682.698,
    r: 50,
    fill: "url(#paint231_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 827.32,
    cy: 682.698,
    r: 50,
    fill: "url(#paint232_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 824.772,
    cy: 682.698,
    r: 50,
    fill: "url(#paint233_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.225,
    cy: 682.698,
    r: 50,
    fill: "url(#paint234_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.676,
    cy: 682.698,
    r: 50,
    fill: "url(#paint235_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.128,
    cy: 682.698,
    r: 50,
    fill: "url(#paint236_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.58,
    cy: 682.698,
    r: 50,
    fill: "url(#paint237_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 812.031,
    cy: 682.698,
    r: 50,
    fill: "url(#paint238_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.483,
    cy: 682.698,
    r: 50,
    fill: "url(#paint239_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806.936,
    cy: 682.698,
    r: 50,
    fill: "url(#paint240_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 804.387,
    cy: 682.698,
    r: 50,
    fill: "url(#paint241_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.839,
    cy: 682.698,
    r: 50,
    fill: "url(#paint242_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 799.291,
    cy: 682.698,
    r: 50,
    fill: "url(#paint243_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.742,
    cy: 682.698,
    r: 50,
    fill: "url(#paint244_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794.194,
    cy: 682.698,
    r: 50,
    fill: "url(#paint245_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 791.646,
    cy: 682.698,
    r: 50,
    fill: "url(#paint246_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 789.098,
    cy: 682.698,
    r: 50,
    fill: "url(#paint247_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.549,
    cy: 682.698,
    r: 50,
    fill: "url(#paint248_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.002,
    cy: 682.698,
    r: 50,
    fill: "url(#paint249_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 781.453,
    cy: 682.698,
    r: 50,
    fill: "url(#paint250_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778.904,
    cy: 682.698,
    r: 50,
    fill: "url(#paint251_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776.356,
    cy: 682.698,
    r: 50,
    fill: "url(#paint252_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.809,
    cy: 682.698,
    r: 50,
    fill: "url(#paint253_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 771.26,
    cy: 682.698,
    r: 50,
    fill: "url(#paint254_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 768.712,
    cy: 682.698,
    r: 50,
    fill: "url(#paint255_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 766.164,
    cy: 682.698,
    r: 50,
    fill: "url(#paint256_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763.615,
    cy: 682.698,
    r: 50,
    fill: "url(#paint257_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 761.067,
    cy: 682.698,
    r: 50,
    fill: "url(#paint258_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 758.52,
    cy: 682.698,
    r: 50,
    fill: "url(#paint259_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755.971,
    cy: 682.698,
    r: 50,
    fill: "url(#paint260_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.423,
    cy: 682.698,
    r: 50,
    fill: "url(#paint261_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750.875,
    cy: 682.698,
    r: 50,
    fill: "url(#paint262_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 748.326,
    cy: 682.698,
    r: 50,
    fill: "url(#paint263_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 745.777,
    cy: 682.698,
    r: 50,
    fill: "url(#paint264_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.23,
    cy: 682.698,
    r: 50,
    fill: "url(#paint265_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.682,
    cy: 682.698,
    r: 50,
    fill: "url(#paint266_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738.133,
    cy: 682.698,
    r: 50,
    fill: "url(#paint267_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 735.586,
    cy: 682.698,
    r: 50,
    fill: "url(#paint268_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 733.037,
    cy: 682.698,
    r: 50,
    fill: "url(#paint269_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730.488,
    cy: 682.698,
    r: 50,
    fill: "url(#paint270_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 727.94,
    cy: 682.698,
    r: 50,
    fill: "url(#paint271_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 725.393,
    cy: 682.698,
    r: 50,
    fill: "url(#paint272_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722.844,
    cy: 682.698,
    r: 50,
    fill: "url(#paint273_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.296,
    cy: 682.698,
    r: 50,
    fill: "url(#paint274_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717.748,
    cy: 682.698,
    r: 50,
    fill: "url(#paint275_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 715.199,
    cy: 682.698,
    r: 50,
    fill: "url(#paint276_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 712.651,
    cy: 682.698,
    r: 50,
    fill: "url(#paint277_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.104,
    cy: 682.698,
    r: 50,
    fill: "url(#paint278_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.555,
    cy: 682.698,
    r: 50,
    fill: "url(#paint279_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 705.007,
    cy: 682.698,
    r: 50,
    fill: "url(#paint280_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 702.459,
    cy: 682.698,
    r: 50,
    fill: "url(#paint281_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.91,
    cy: 682.698,
    r: 50,
    fill: "url(#paint282_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.361,
    cy: 682.698,
    r: 50,
    fill: "url(#paint283_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 694.814,
    cy: 682.698,
    r: 50,
    fill: "url(#paint284_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.266,
    cy: 682.698,
    r: 50,
    fill: "url(#paint285_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689.717,
    cy: 682.698,
    r: 50,
    fill: "url(#paint286_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 687.169,
    cy: 682.698,
    r: 50,
    fill: "url(#paint287_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 684.621,
    cy: 682.698,
    r: 50,
    fill: "url(#paint288_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682.072,
    cy: 682.698,
    r: 50,
    fill: "url(#paint289_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.524,
    cy: 682.698,
    r: 50,
    fill: "url(#paint290_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676.977,
    cy: 682.698,
    r: 50,
    fill: "url(#paint291_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.428,
    cy: 682.698,
    r: 50,
    fill: "url(#paint292_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 671.88,
    cy: 682.698,
    r: 50,
    fill: "url(#paint293_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 669.332,
    cy: 682.698,
    r: 50,
    fill: "url(#paint294_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.783,
    cy: 682.698,
    r: 50,
    fill: "url(#paint295_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 664.235,
    cy: 682.698,
    r: 50,
    fill: "url(#paint296_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 661.688,
    cy: 682.698,
    r: 50,
    fill: "url(#paint297_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 659.139,
    cy: 682.698,
    r: 50,
    fill: "url(#paint298_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.591,
    cy: 682.698,
    r: 50,
    fill: "url(#paint299_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 654.043,
    cy: 682.698,
    r: 50,
    fill: "url(#paint300_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.494,
    cy: 682.698,
    r: 50,
    fill: "url(#paint301_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648.945,
    cy: 682.698,
    r: 50,
    fill: "url(#paint302_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 646.398,
    cy: 682.698,
    r: 50,
    fill: "url(#paint303_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.85,
    cy: 682.698,
    r: 50,
    fill: "url(#paint304_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 641.301,
    cy: 682.698,
    r: 50,
    fill: "url(#paint305_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 638.753,
    cy: 682.698,
    r: 50,
    fill: "url(#paint306_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636.205,
    cy: 682.698,
    r: 50,
    fill: "url(#paint307_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 633.656,
    cy: 682.698,
    r: 50,
    fill: "url(#paint308_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 631.108,
    cy: 682.698,
    r: 50,
    fill: "url(#paint309_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.561,
    cy: 682.698,
    r: 50,
    fill: "url(#paint310_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626.012,
    cy: 682.698,
    r: 50,
    fill: "url(#paint311_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.464,
    cy: 682.698,
    r: 50,
    fill: "url(#paint312_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.916,
    cy: 682.698,
    r: 50,
    fill: "url(#paint313_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618.367,
    cy: 682.698,
    r: 50,
    fill: "url(#paint314_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 615.819,
    cy: 682.698,
    r: 50,
    fill: "url(#paint315_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 613.271,
    cy: 682.698,
    r: 50,
    fill: "url(#paint316_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.723,
    cy: 682.698,
    r: 50,
    fill: "url(#paint317_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 608.175,
    cy: 682.698,
    r: 50,
    fill: "url(#paint318_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 605.627,
    cy: 682.698,
    r: 50,
    fill: "url(#paint319_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 603.078,
    cy: 682.698,
    r: 50,
    fill: "url(#paint320_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.529,
    cy: 682.698,
    r: 50,
    fill: "url(#paint321_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.982,
    cy: 682.698,
    r: 50,
    fill: "url(#paint322_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.434,
    cy: 682.698,
    r: 50,
    fill: "url(#paint323_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 592.885,
    cy: 682.698,
    r: 50,
    fill: "url(#paint324_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 590.337,
    cy: 682.698,
    r: 50,
    fill: "url(#paint325_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 587.789,
    cy: 682.698,
    r: 50,
    fill: "url(#paint326_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585.24,
    cy: 682.698,
    r: 50,
    fill: "url(#paint327_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.692,
    cy: 682.698,
    r: 50,
    fill: "url(#paint328_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.145,
    cy: 682.698,
    r: 50,
    fill: "url(#paint329_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.596,
    cy: 682.698,
    r: 50,
    fill: "url(#paint330_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.048,
    cy: 682.698,
    r: 50,
    fill: "url(#paint331_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.5,
    cy: 682.698,
    r: 50,
    fill: "url(#paint332_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.951,
    cy: 682.698,
    r: 50,
    fill: "url(#paint333_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.403,
    cy: 682.698,
    r: 50,
    fill: "url(#paint334_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.855,
    cy: 682.698,
    r: 50,
    fill: "url(#paint335_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.307,
    cy: 682.698,
    r: 50,
    fill: "url(#paint336_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.758,
    cy: 682.698,
    r: 50,
    fill: "url(#paint337_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.211,
    cy: 682.698,
    r: 50,
    fill: "url(#paint338_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.662,
    cy: 682.698,
    r: 50,
    fill: "url(#paint339_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552.113,
    cy: 682.698,
    r: 50,
    fill: "url(#paint340_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.566,
    cy: 682.698,
    r: 50,
    fill: "url(#paint341_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.018,
    cy: 682.698,
    r: 50,
    fill: "url(#paint342_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544.469,
    cy: 682.698,
    r: 50,
    fill: "url(#paint343_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541.921,
    cy: 682.698,
    r: 50,
    fill: "url(#paint344_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.373,
    cy: 682.698,
    r: 50,
    fill: "url(#paint345_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 536.824,
    cy: 682.698,
    r: 50,
    fill: "url(#paint346_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534.276,
    cy: 682.698,
    r: 50,
    fill: "url(#paint347_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.729,
    cy: 682.698,
    r: 50,
    fill: "url(#paint348_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.18,
    cy: 682.698,
    r: 50,
    fill: "url(#paint349_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 526.632,
    cy: 682.698,
    r: 50,
    fill: "url(#paint350_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.084,
    cy: 682.698,
    r: 50,
    fill: "url(#paint351_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.535,
    cy: 682.698,
    r: 50,
    fill: "url(#paint352_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 518.987,
    cy: 682.698,
    r: 50,
    fill: "url(#paint353_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.439,
    cy: 682.698,
    r: 50,
    fill: "url(#paint354_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.891,
    cy: 682.698,
    r: 50,
    fill: "url(#paint355_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.342,
    cy: 682.698,
    r: 50,
    fill: "url(#paint356_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 508.795,
    cy: 682.698,
    r: 50,
    fill: "url(#paint357_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.246,
    cy: 682.698,
    r: 50,
    fill: "url(#paint358_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.697,
    cy: 682.698,
    r: 50,
    fill: "url(#paint359_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.149,
    cy: 682.698,
    r: 50,
    fill: "url(#paint360_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.602,
    cy: 682.698,
    r: 50,
    fill: "url(#paint361_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.053,
    cy: 682.698,
    r: 50,
    fill: "url(#paint362_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.505,
    cy: 682.698,
    r: 50,
    fill: "url(#paint363_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.174,
    cy: 684.567,
    r: 50,
    fill: "url(#paint364_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.144,
    cy: 686.897,
    r: 50,
    fill: "url(#paint365_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.113,
    cy: 689.229,
    r: 50,
    fill: "url(#paint366_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.083,
    cy: 691.559,
    r: 50,
    fill: "url(#paint367_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.053,
    cy: 693.89,
    r: 50,
    fill: "url(#paint368_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.022,
    cy: 696.221,
    r: 50,
    fill: "url(#paint369_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.992,
    cy: 698.551,
    r: 50,
    fill: "url(#paint370_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 484.963,
    cy: 700.882,
    r: 50,
    fill: "url(#paint371_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.932,
    cy: 703.212,
    r: 50,
    fill: "url(#paint372_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482.902,
    cy: 705.543,
    r: 50,
    fill: "url(#paint373_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.871,
    cy: 707.874,
    r: 50,
    fill: "url(#paint374_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.842,
    cy: 710.204,
    r: 50,
    fill: "url(#paint375_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.811,
    cy: 712.535,
    r: 50,
    fill: "url(#paint376_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.781,
    cy: 714.865,
    r: 50,
    fill: "url(#paint377_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.75,
    cy: 717.196,
    r: 50,
    fill: "url(#paint378_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.721,
    cy: 719.527,
    r: 50,
    fill: "url(#paint379_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.689,
    cy: 721.857,
    r: 50,
    fill: "url(#paint380_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.66,
    cy: 724.188,
    r: 50,
    fill: "url(#paint381_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.629,
    cy: 726.519,
    r: 50,
    fill: "url(#paint382_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.6,
    cy: 728.85,
    r: 50,
    fill: "url(#paint383_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 471.568,
    cy: 731.181,
    r: 50,
    fill: "url(#paint384_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.539,
    cy: 733.511,
    r: 50,
    fill: "url(#paint385_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469.508,
    cy: 735.842,
    r: 50,
    fill: "url(#paint386_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.479,
    cy: 738.172,
    r: 50,
    fill: "url(#paint387_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.448,
    cy: 740.503,
    r: 50,
    fill: "url(#paint388_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.418,
    cy: 742.834,
    r: 50,
    fill: "url(#paint389_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.388,
    cy: 745.164,
    r: 50,
    fill: "url(#paint390_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 464.357,
    cy: 747.495,
    r: 50,
    fill: "url(#paint391_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.327,
    cy: 749.825,
    r: 50,
    fill: "url(#paint392_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.297,
    cy: 752.156,
    r: 50,
    fill: "url(#paint393_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 461.267,
    cy: 754.487,
    r: 50,
    fill: "url(#paint394_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.236,
    cy: 756.817,
    r: 50,
    fill: "url(#paint395_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.206,
    cy: 759.148,
    r: 50,
    fill: "url(#paint396_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458.176,
    cy: 761.479,
    r: 50,
    fill: "url(#paint397_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.146,
    cy: 763.81,
    r: 50,
    fill: "url(#paint398_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.115,
    cy: 766.141,
    r: 50,
    fill: "url(#paint399_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.085,
    cy: 768.471,
    r: 50,
    fill: "url(#paint400_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.055,
    cy: 770.802,
    r: 50,
    fill: "url(#paint401_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453.024,
    cy: 773.132,
    r: 50,
    fill: "url(#paint402_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.994,
    cy: 775.463,
    r: 50,
    fill: "url(#paint403_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.964,
    cy: 777.793,
    r: 50,
    fill: "url(#paint404_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.934,
    cy: 780.124,
    r: 50,
    fill: "url(#paint405_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448.904,
    cy: 782.455,
    r: 50,
    fill: "url(#paint406_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.873,
    cy: 784.785,
    r: 50,
    fill: "url(#paint407_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.844,
    cy: 787.116,
    r: 50,
    fill: "url(#paint408_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.812,
    cy: 789.446,
    r: 50,
    fill: "url(#paint409_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.783,
    cy: 791.777,
    r: 50,
    fill: "url(#paint410_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.752,
    cy: 794.108,
    r: 50,
    fill: "url(#paint411_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.723,
    cy: 796.438,
    r: 50,
    fill: "url(#paint412_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.691,
    cy: 798.77,
    r: 50,
    fill: "url(#paint413_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440.662,
    cy: 801.1,
    r: 50,
    fill: "url(#paint414_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.631,
    cy: 803.431,
    r: 50,
    fill: "url(#paint415_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.602,
    cy: 805.762,
    r: 50,
    fill: "url(#paint416_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 437.57,
    cy: 808.092,
    r: 50,
    fill: "url(#paint417_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.541,
    cy: 810.423,
    r: 50,
    fill: "url(#paint418_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.51,
    cy: 812.753,
    r: 50,
    fill: "url(#paint419_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.48,
    cy: 815.084,
    r: 50,
    fill: "url(#paint420_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.449,
    cy: 817.415,
    r: 50,
    fill: "url(#paint421_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.42,
    cy: 819.745,
    r: 50,
    fill: "url(#paint422_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.39,
    cy: 822.076,
    r: 50,
    fill: "url(#paint423_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.359,
    cy: 824.406,
    r: 50,
    fill: "url(#paint424_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.329,
    cy: 826.737,
    r: 50,
    fill: "url(#paint425_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.299,
    cy: 829.068,
    r: 50,
    fill: "url(#paint426_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.269,
    cy: 831.398,
    r: 50,
    fill: "url(#paint427_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.238,
    cy: 833.729,
    r: 50,
    fill: "url(#paint428_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.208,
    cy: 836.06,
    r: 50,
    fill: "url(#paint429_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.178,
    cy: 838.391,
    r: 50,
    fill: "url(#paint430_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.147,
    cy: 840.722,
    r: 50,
    fill: "url(#paint431_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.117,
    cy: 843.052,
    r: 50,
    fill: "url(#paint432_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.087,
    cy: 845.383,
    r: 50,
    fill: "url(#paint433_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.057,
    cy: 847.713,
    r: 50,
    fill: "url(#paint434_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.026,
    cy: 850.044,
    r: 50,
    fill: "url(#paint435_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.996,
    cy: 852.375,
    r: 50,
    fill: "url(#paint436_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.966,
    cy: 854.705,
    r: 50,
    fill: "url(#paint437_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.936,
    cy: 857.036,
    r: 50,
    fill: "url(#paint438_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.905,
    cy: 859.366,
    r: 50,
    fill: "url(#paint439_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.875,
    cy: 861.697,
    r: 50,
    fill: "url(#paint440_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.846,
    cy: 864.028,
    r: 50,
    fill: "url(#paint441_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.814,
    cy: 866.358,
    r: 50,
    fill: "url(#paint442_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.785,
    cy: 868.689,
    r: 50,
    fill: "url(#paint443_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.754,
    cy: 871.02,
    r: 50,
    fill: "url(#paint444_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.725,
    cy: 873.351,
    r: 50,
    fill: "url(#paint445_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.693,
    cy: 875.682,
    r: 50,
    fill: "url(#paint446_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.664,
    cy: 878.012,
    r: 50,
    fill: "url(#paint447_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.633,
    cy: 880.343,
    r: 50,
    fill: "url(#paint448_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.604,
    cy: 882.673,
    r: 50,
    fill: "url(#paint449_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.572,
    cy: 885.004,
    r: 50,
    fill: "url(#paint450_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.543,
    cy: 887.335,
    r: 50,
    fill: "url(#paint451_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.512,
    cy: 889.665,
    r: 50,
    fill: "url(#paint452_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.482,
    cy: 891.996,
    r: 50,
    fill: "url(#paint453_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.451,
    cy: 894.326,
    r: 50,
    fill: "url(#paint454_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.422,
    cy: 896.657,
    r: 50,
    fill: "url(#paint455_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.391,
    cy: 898.988,
    r: 50,
    fill: "url(#paint456_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.361,
    cy: 901.318,
    r: 50,
    fill: "url(#paint457_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.331,
    cy: 903.649,
    r: 50,
    fill: "url(#paint458_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.301,
    cy: 905.979,
    r: 50,
    fill: "url(#paint459_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.271,
    cy: 908.311,
    r: 50,
    fill: "url(#paint460_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.24,
    cy: 910.642,
    r: 50,
    fill: "url(#paint461_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.21,
    cy: 912.972,
    r: 50,
    fill: "url(#paint462_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.18,
    cy: 915.303,
    r: 50,
    fill: "url(#paint463_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.149,
    cy: 917.633,
    r: 50,
    fill: "url(#paint464_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.119,
    cy: 919.964,
    r: 50,
    fill: "url(#paint465_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.089,
    cy: 922.295,
    r: 50,
    fill: "url(#paint466_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.059,
    cy: 924.625,
    r: 50,
    fill: "url(#paint467_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.028,
    cy: 926.956,
    r: 50,
    fill: "url(#paint468_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.998,
    cy: 929.286,
    r: 50,
    fill: "url(#paint469_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.968,
    cy: 931.617,
    r: 50,
    fill: "url(#paint470_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.938,
    cy: 933.947,
    r: 50,
    fill: "url(#paint471_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.907,
    cy: 936.278,
    r: 50,
    fill: "url(#paint472_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.877,
    cy: 938.609,
    r: 50,
    fill: "url(#paint473_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.847,
    cy: 940.939,
    r: 50,
    fill: "url(#paint474_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.816,
    cy: 943.271,
    r: 50,
    fill: "url(#paint475_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.787,
    cy: 945.601,
    r: 50,
    fill: "url(#paint476_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.756,
    cy: 947.932,
    r: 50,
    fill: "url(#paint477_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.727,
    cy: 950.263,
    r: 50,
    fill: "url(#paint478_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.695,
    cy: 952.593,
    r: 50,
    fill: "url(#paint479_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.666,
    cy: 954.924,
    r: 50,
    fill: "url(#paint480_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.635,
    cy: 957.254,
    r: 50,
    fill: "url(#paint481_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.605,
    cy: 959.585,
    r: 50,
    fill: "url(#paint482_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.574,
    cy: 961.916,
    r: 50,
    fill: "url(#paint483_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.545,
    cy: 964.246,
    r: 50,
    fill: "url(#paint484_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.514,
    cy: 966.577,
    r: 50,
    fill: "url(#paint485_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.484,
    cy: 968.907,
    r: 50,
    fill: "url(#paint486_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.453,
    cy: 971.238,
    r: 50,
    fill: "url(#paint487_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.424,
    cy: 973.569,
    r: 50,
    fill: "url(#paint488_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.393,
    cy: 975.899,
    r: 50,
    fill: "url(#paint489_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.363,
    cy: 978.23,
    r: 50,
    fill: "url(#paint490_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.332,
    cy: 980.561,
    r: 50,
    fill: "url(#paint491_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.303,
    cy: 982.892,
    r: 50,
    fill: "url(#paint492_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.271,
    cy: 985.223,
    r: 50,
    fill: "url(#paint493_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.242,
    cy: 987.553,
    r: 50,
    fill: "url(#paint494_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.212,
    cy: 989.884,
    r: 50,
    fill: "url(#paint495_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.182,
    cy: 992.214,
    r: 50,
    fill: "url(#paint496_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.151,
    cy: 994.545,
    r: 50,
    fill: "url(#paint497_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.121,
    cy: 996.876,
    r: 50,
    fill: "url(#paint498_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.091,
    cy: 999.206,
    r: 50,
    fill: "url(#paint499_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.061,
    cy: 1001.54,
    r: 50,
    fill: "url(#paint500_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.03,
    cy: 1003.87,
    r: 50,
    fill: "url(#paint501_linear_2728_79481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 1006.2,
    r: 50,
    fill: "url(#paint502_linear_2728_79481)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2728_79481",
    x: 0,
    y: 0,
    width: 1630.7,
    height: 1356.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2728_79481"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2728_79481",
    x1: 1232.89,
    y1: 302.83,
    x2: 1312.42,
    y2: 311.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2728_79481",
    x1: 1231.08,
    y1: 304.632,
    x2: 1310.62,
    y2: 313.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2728_79481",
    x1: 1229.28,
    y1: 306.434,
    x2: 1308.82,
    y2: 315.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2728_79481",
    x1: 1227.48,
    y1: 308.235,
    x2: 1307.02,
    y2: 316.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2728_79481",
    x1: 1225.68,
    y1: 310.038,
    x2: 1305.22,
    y2: 318.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2728_79481",
    x1: 1223.88,
    y1: 311.84,
    x2: 1303.41,
    y2: 320.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2728_79481",
    x1: 1222.07,
    y1: 313.642,
    x2: 1301.61,
    y2: 322.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2728_79481",
    x1: 1220.27,
    y1: 315.444,
    x2: 1299.81,
    y2: 324.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2728_79481",
    x1: 1218.47,
    y1: 317.245,
    x2: 1298.01,
    y2: 325.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2728_79481",
    x1: 1216.67,
    y1: 319.047,
    x2: 1296.21,
    y2: 327.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2728_79481",
    x1: 1214.87,
    y1: 320.849,
    x2: 1294.4,
    y2: 329.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2728_79481",
    x1: 1213.07,
    y1: 322.651,
    x2: 1292.6,
    y2: 331.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2728_79481",
    x1: 1211.26,
    y1: 324.452,
    x2: 1290.8,
    y2: 333.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2728_79481",
    x1: 1209.46,
    y1: 326.254,
    x2: 1289,
    y2: 334.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2728_79481",
    x1: 1207.66,
    y1: 328.057,
    x2: 1287.2,
    y2: 336.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2728_79481",
    x1: 1205.86,
    y1: 329.859,
    x2: 1285.4,
    y2: 338.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2728_79481",
    x1: 1204.06,
    y1: 331.66,
    x2: 1283.59,
    y2: 340.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2728_79481",
    x1: 1202.25,
    y1: 333.462,
    x2: 1281.79,
    y2: 342.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2728_79481",
    x1: 1200.45,
    y1: 335.264,
    x2: 1279.99,
    y2: 343.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2728_79481",
    x1: 1198.65,
    y1: 337.066,
    x2: 1278.19,
    y2: 345.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2728_79481",
    x1: 1196.85,
    y1: 338.867,
    x2: 1276.39,
    y2: 347.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2728_79481",
    x1: 1195.05,
    y1: 340.669,
    x2: 1274.58,
    y2: 349.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2728_79481",
    x1: 1193.24,
    y1: 342.471,
    x2: 1272.78,
    y2: 351.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2728_79481",
    x1: 1191.44,
    y1: 344.273,
    x2: 1270.98,
    y2: 352.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2728_79481",
    x1: 1189.64,
    y1: 346.075,
    x2: 1269.18,
    y2: 354.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2728_79481",
    x1: 1187.84,
    y1: 347.877,
    x2: 1267.38,
    y2: 356.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2728_79481",
    x1: 1186.04,
    y1: 349.679,
    x2: 1265.57,
    y2: 358.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2728_79481",
    x1: 1184.24,
    y1: 351.481,
    x2: 1263.77,
    y2: 360.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2728_79481",
    x1: 1182.43,
    y1: 353.282,
    x2: 1261.97,
    y2: 361.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2728_79481",
    x1: 1180.63,
    y1: 355.084,
    x2: 1260.17,
    y2: 363.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2728_79481",
    x1: 1178.83,
    y1: 356.886,
    x2: 1258.37,
    y2: 365.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2728_79481",
    x1: 1177.03,
    y1: 358.688,
    x2: 1256.57,
    y2: 367.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2728_79481",
    x1: 1175.23,
    y1: 360.489,
    x2: 1254.76,
    y2: 369.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2728_79481",
    x1: 1173.42,
    y1: 362.292,
    x2: 1252.96,
    y2: 370.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2728_79481",
    x1: 1171.62,
    y1: 364.094,
    x2: 1251.16,
    y2: 372.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2728_79481",
    x1: 1169.82,
    y1: 365.896,
    x2: 1249.36,
    y2: 374.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2728_79481",
    x1: 1168.02,
    y1: 367.697,
    x2: 1247.56,
    y2: 376.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2728_79481",
    x1: 1166.22,
    y1: 369.499,
    x2: 1245.75,
    y2: 378.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2728_79481",
    x1: 1164.42,
    y1: 371.301,
    x2: 1243.95,
    y2: 379.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2728_79481",
    x1: 1162.61,
    y1: 373.103,
    x2: 1242.15,
    y2: 381.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2728_79481",
    x1: 1160.81,
    y1: 374.904,
    x2: 1240.35,
    y2: 383.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2728_79481",
    x1: 1159.01,
    y1: 376.706,
    x2: 1238.55,
    y2: 385.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2728_79481",
    x1: 1157.21,
    y1: 378.508,
    x2: 1236.74,
    y2: 387.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2728_79481",
    x1: 1155.41,
    y1: 380.311,
    x2: 1234.94,
    y2: 388.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2728_79481",
    x1: 1153.6,
    y1: 382.112,
    x2: 1233.14,
    y2: 390.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2728_79481",
    x1: 1151.8,
    y1: 383.914,
    x2: 1231.34,
    y2: 392.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2728_79481",
    x1: 1150,
    y1: 385.716,
    x2: 1229.54,
    y2: 394.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2728_79481",
    x1: 1148.2,
    y1: 387.518,
    x2: 1227.74,
    y2: 396.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2728_79481",
    x1: 1146.4,
    y1: 389.319,
    x2: 1225.93,
    y2: 397.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2728_79481",
    x1: 1144.59,
    y1: 391.121,
    x2: 1224.13,
    y2: 399.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2728_79481",
    x1: 1142.79,
    y1: 392.923,
    x2: 1222.33,
    y2: 401.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2728_79481",
    x1: 1140.99,
    y1: 394.725,
    x2: 1220.53,
    y2: 403.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2728_79481",
    x1: 1139.19,
    y1: 396.527,
    x2: 1218.73,
    y2: 405.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2728_79481",
    x1: 1137.39,
    y1: 398.329,
    x2: 1216.92,
    y2: 406.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2728_79481",
    x1: 1135.59,
    y1: 400.131,
    x2: 1215.12,
    y2: 408.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2728_79481",
    x1: 1133.78,
    y1: 401.933,
    x2: 1213.32,
    y2: 410.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2728_79481",
    x1: 1131.98,
    y1: 403.735,
    x2: 1211.52,
    y2: 412.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2728_79481",
    x1: 1130.18,
    y1: 405.536,
    x2: 1209.72,
    y2: 414.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2728_79481",
    x1: 1128.38,
    y1: 407.338,
    x2: 1207.92,
    y2: 415.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2728_79481",
    x1: 1126.58,
    y1: 409.14,
    x2: 1206.11,
    y2: 417.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2728_79481",
    x1: 1124.77,
    y1: 410.942,
    x2: 1204.31,
    y2: 419.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2728_79481",
    x1: 1122.97,
    y1: 412.743,
    x2: 1202.51,
    y2: 421.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2728_79481",
    x1: 1121.17,
    y1: 414.545,
    x2: 1200.71,
    y2: 423.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2728_79481",
    x1: 1119.37,
    y1: 416.348,
    x2: 1198.91,
    y2: 424.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2728_79481",
    x1: 1117.57,
    y1: 418.15,
    x2: 1197.1,
    y2: 426.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2728_79481",
    x1: 1115.76,
    y1: 419.951,
    x2: 1195.3,
    y2: 428.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2728_79481",
    x1: 1113.96,
    y1: 421.753,
    x2: 1193.5,
    y2: 430.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2728_79481",
    x1: 1112.16,
    y1: 423.555,
    x2: 1191.7,
    y2: 432.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2728_79481",
    x1: 1110.36,
    y1: 425.357,
    x2: 1189.9,
    y2: 433.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2728_79481",
    x1: 1108.56,
    y1: 427.158,
    x2: 1188.1,
    y2: 435.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2728_79481",
    x1: 1106.76,
    y1: 428.96,
    x2: 1186.29,
    y2: 437.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2728_79481",
    x1: 1104.95,
    y1: 430.762,
    x2: 1184.49,
    y2: 439.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2728_79481",
    x1: 1103.15,
    y1: 432.565,
    x2: 1182.69,
    y2: 441.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2728_79481",
    x1: 1101.35,
    y1: 434.366,
    x2: 1180.89,
    y2: 442.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2728_79481",
    x1: 1099.55,
    y1: 436.168,
    x2: 1179.09,
    y2: 444.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2728_79481",
    x1: 1097.75,
    y1: 437.97,
    x2: 1177.28,
    y2: 446.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2728_79481",
    x1: 1095.94,
    y1: 439.772,
    x2: 1175.48,
    y2: 448.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2728_79481",
    x1: 1094.14,
    y1: 441.573,
    x2: 1173.68,
    y2: 450.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2728_79481",
    x1: 1092.34,
    y1: 443.375,
    x2: 1171.88,
    y2: 451.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2728_79481",
    x1: 1090.54,
    y1: 445.177,
    x2: 1170.08,
    y2: 453.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2728_79481",
    x1: 1088.74,
    y1: 446.979,
    x2: 1168.27,
    y2: 455.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2728_79481",
    x1: 1086.94,
    y1: 448.78,
    x2: 1166.47,
    y2: 457.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2728_79481",
    x1: 1085.13,
    y1: 450.583,
    x2: 1164.67,
    y2: 459.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2728_79481",
    x1: 1083.33,
    y1: 452.385,
    x2: 1162.87,
    y2: 460.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2728_79481",
    x1: 1081.53,
    y1: 454.187,
    x2: 1161.07,
    y2: 462.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2728_79481",
    x1: 1079.73,
    y1: 455.988,
    x2: 1159.27,
    y2: 464.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2728_79481",
    x1: 1077.93,
    y1: 457.79,
    x2: 1157.46,
    y2: 466.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2728_79481",
    x1: 1076.12,
    y1: 459.592,
    x2: 1155.66,
    y2: 468.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2728_79481",
    x1: 1074.32,
    y1: 461.394,
    x2: 1153.86,
    y2: 469.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2728_79481",
    x1: 1072.52,
    y1: 463.195,
    x2: 1152.06,
    y2: 471.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2728_79481",
    x1: 1070.72,
    y1: 464.997,
    x2: 1150.26,
    y2: 473.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2728_79481",
    x1: 1068.92,
    y1: 466.799,
    x2: 1148.45,
    y2: 475.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2728_79481",
    x1: 1067.12,
    y1: 468.602,
    x2: 1146.65,
    y2: 477.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2728_79481",
    x1: 1065.31,
    y1: 470.403,
    x2: 1144.85,
    y2: 478.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2728_79481",
    x1: 1063.51,
    y1: 472.205,
    x2: 1143.05,
    y2: 480.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2728_79481",
    x1: 1061.71,
    y1: 474.007,
    x2: 1141.25,
    y2: 482.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2728_79481",
    x1: 1059.91,
    y1: 475.809,
    x2: 1139.45,
    y2: 484.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2728_79481",
    x1: 1058.11,
    y1: 477.61,
    x2: 1137.64,
    y2: 486.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2728_79481",
    x1: 1056.3,
    y1: 479.412,
    x2: 1135.84,
    y2: 488.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2728_79481",
    x1: 1054.5,
    y1: 481.214,
    x2: 1134.04,
    y2: 489.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2728_79481",
    x1: 1052.7,
    y1: 483.016,
    x2: 1132.24,
    y2: 491.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2728_79481",
    x1: 1050.9,
    y1: 484.819,
    x2: 1130.44,
    y2: 493.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2728_79481",
    x1: 1049.1,
    y1: 486.62,
    x2: 1128.63,
    y2: 495.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2728_79481",
    x1: 1047.29,
    y1: 488.422,
    x2: 1126.83,
    y2: 497.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2728_79481",
    x1: 1045.49,
    y1: 490.224,
    x2: 1125.03,
    y2: 498.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2728_79481",
    x1: 1043.69,
    y1: 492.026,
    x2: 1123.23,
    y2: 500.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2728_79481",
    x1: 1041.89,
    y1: 493.827,
    x2: 1121.43,
    y2: 502.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2728_79481",
    x1: 1040.09,
    y1: 495.629,
    x2: 1119.62,
    y2: 504.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2728_79481",
    x1: 1038.29,
    y1: 497.431,
    x2: 1117.82,
    y2: 506.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2728_79481",
    x1: 1036.48,
    y1: 499.233,
    x2: 1116.02,
    y2: 507.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2728_79481",
    x1: 1034.68,
    y1: 501.034,
    x2: 1114.22,
    y2: 509.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2728_79481",
    x1: 1032.88,
    y1: 502.837,
    x2: 1112.42,
    y2: 511.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2728_79481",
    x1: 1031.08,
    y1: 504.639,
    x2: 1110.62,
    y2: 513.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2728_79481",
    x1: 1029.28,
    y1: 506.441,
    x2: 1108.81,
    y2: 515.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2728_79481",
    x1: 1027.47,
    y1: 508.242,
    x2: 1107.01,
    y2: 516.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2728_79481",
    x1: 1025.67,
    y1: 510.044,
    x2: 1105.21,
    y2: 518.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2728_79481",
    x1: 1023.87,
    y1: 511.846,
    x2: 1103.41,
    y2: 520.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2728_79481",
    x1: 1022.07,
    y1: 513.648,
    x2: 1101.61,
    y2: 522.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2728_79481",
    x1: 1020.27,
    y1: 515.449,
    x2: 1099.8,
    y2: 524.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2728_79481",
    x1: 1018.46,
    y1: 517.251,
    x2: 1098,
    y2: 525.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2728_79481",
    x1: 1016.66,
    y1: 519.053,
    x2: 1096.2,
    y2: 527.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2728_79481",
    x1: 1014.86,
    y1: 520.856,
    x2: 1094.4,
    y2: 529.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2728_79481",
    x1: 1013.06,
    y1: 522.657,
    x2: 1092.6,
    y2: 531.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2728_79481",
    x1: 1011.26,
    y1: 524.459,
    x2: 1090.79,
    y2: 533.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2728_79481",
    x1: 1009.46,
    y1: 526.261,
    x2: 1088.99,
    y2: 534.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2728_79481",
    x1: 1007.65,
    y1: 528.063,
    x2: 1087.19,
    y2: 536.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2728_79481",
    x1: 1005.85,
    y1: 529.864,
    x2: 1085.39,
    y2: 538.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2728_79481",
    x1: 1004.05,
    y1: 531.666,
    x2: 1083.59,
    y2: 540.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2728_79481",
    x1: 1002.25,
    y1: 533.468,
    x2: 1081.79,
    y2: 542.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2728_79481",
    x1: 1000.45,
    y1: 535.27,
    x2: 1079.98,
    y2: 543.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2728_79481",
    x1: 998.645,
    y1: 537.072,
    x2: 1078.18,
    y2: 545.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2728_79481",
    x1: 996.842,
    y1: 538.874,
    x2: 1076.38,
    y2: 547.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2728_79481",
    x1: 995.041,
    y1: 540.676,
    x2: 1074.58,
    y2: 549.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2728_79481",
    x1: 993.238,
    y1: 542.478,
    x2: 1072.78,
    y2: 551.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2728_79481",
    x1: 991.437,
    y1: 544.279,
    x2: 1070.97,
    y2: 552.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2728_79481",
    x1: 989.635,
    y1: 546.081,
    x2: 1069.17,
    y2: 554.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2728_79481",
    x1: 987.833,
    y1: 547.883,
    x2: 1067.37,
    y2: 556.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2728_79481",
    x1: 986.031,
    y1: 549.685,
    x2: 1065.57,
    y2: 558.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2728_79481",
    x1: 984.229,
    y1: 551.486,
    x2: 1063.77,
    y2: 560.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2728_79481",
    x1: 982.428,
    y1: 553.288,
    x2: 1061.97,
    y2: 561.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2728_79481",
    x1: 980.625,
    y1: 555.091,
    x2: 1060.16,
    y2: 563.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2728_79481",
    x1: 978.824,
    y1: 556.893,
    x2: 1058.36,
    y2: 565.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2728_79481",
    x1: 977.021,
    y1: 558.694,
    x2: 1056.56,
    y2: 567.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2728_79481",
    x1: 975.22,
    y1: 560.496,
    x2: 1054.76,
    y2: 569.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2728_79481",
    x1: 973.418,
    y1: 562.298,
    x2: 1052.96,
    y2: 570.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2728_79481",
    x1: 971.616,
    y1: 564.1,
    x2: 1051.15,
    y2: 572.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2728_79481",
    x1: 969.814,
    y1: 565.902,
    x2: 1049.35,
    y2: 574.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2728_79481",
    x1: 968.012,
    y1: 567.703,
    x2: 1047.55,
    y2: 576.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2728_79481",
    x1: 966.211,
    y1: 569.505,
    x2: 1045.75,
    y2: 578.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2728_79481",
    x1: 964.408,
    y1: 571.307,
    x2: 1043.95,
    y2: 579.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2728_79481",
    x1: 962.607,
    y1: 573.11,
    x2: 1042.15,
    y2: 581.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2728_79481",
    x1: 960.805,
    y1: 574.911,
    x2: 1040.34,
    y2: 583.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2728_79481",
    x1: 959.003,
    y1: 576.713,
    x2: 1038.54,
    y2: 585.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2728_79481",
    x1: 957.201,
    y1: 578.515,
    x2: 1036.74,
    y2: 587.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2728_79481",
    x1: 955.399,
    y1: 580.317,
    x2: 1034.94,
    y2: 588.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2728_79481",
    x1: 953.598,
    y1: 582.118,
    x2: 1033.14,
    y2: 590.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2728_79481",
    x1: 951.796,
    y1: 583.92,
    x2: 1031.33,
    y2: 592.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2728_79481",
    x1: 949.994,
    y1: 585.722,
    x2: 1029.53,
    y2: 594.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2728_79481",
    x1: 948.191,
    y1: 587.524,
    x2: 1027.73,
    y2: 596.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2728_79481",
    x1: 946.391,
    y1: 589.325,
    x2: 1025.93,
    y2: 597.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2728_79481",
    x1: 944.588,
    y1: 591.128,
    x2: 1024.13,
    y2: 599.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2728_79481",
    x1: 942.787,
    y1: 592.93,
    x2: 1022.32,
    y2: 601.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2728_79481",
    x1: 940.984,
    y1: 594.732,
    x2: 1020.52,
    y2: 603.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2728_79481",
    x1: 939.183,
    y1: 596.533,
    x2: 1018.72,
    y2: 605.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2728_79481",
    x1: 937.381,
    y1: 598.335,
    x2: 1016.92,
    y2: 606.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2728_79481",
    x1: 935.579,
    y1: 600.137,
    x2: 1015.12,
    y2: 608.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2728_79481",
    x1: 933.777,
    y1: 601.939,
    x2: 1013.32,
    y2: 610.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2728_79481",
    x1: 931.975,
    y1: 603.74,
    x2: 1011.51,
    y2: 612.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2728_79481",
    x1: 930.174,
    y1: 605.542,
    x2: 1009.71,
    y2: 614.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2728_79481",
    x1: 928.371,
    y1: 607.345,
    x2: 1007.91,
    y2: 615.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2728_79481",
    x1: 926.57,
    y1: 609.147,
    x2: 1006.11,
    y2: 617.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2728_79481",
    x1: 924.768,
    y1: 610.948,
    x2: 1004.31,
    y2: 619.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2728_79481",
    x1: 922.966,
    y1: 612.75,
    x2: 1002.5,
    y2: 621.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2728_79481",
    x1: 921.164,
    y1: 614.552,
    x2: 1000.7,
    y2: 623.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2728_79481",
    x1: 919.362,
    y1: 616.354,
    x2: 998.9,
    y2: 624.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2728_79481",
    x1: 917.561,
    y1: 618.155,
    x2: 997.098,
    y2: 626.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2728_79481",
    x1: 915.759,
    y1: 619.957,
    x2: 995.297,
    y2: 628.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2728_79481",
    x1: 913.957,
    y1: 621.759,
    x2: 993.495,
    y2: 630.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2728_79481",
    x1: 912.154,
    y1: 623.561,
    x2: 991.692,
    y2: 632.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2728_79481",
    x1: 910.354,
    y1: 625.363,
    x2: 989.891,
    y2: 633.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2728_79481",
    x1: 908.551,
    y1: 627.165,
    x2: 988.089,
    y2: 635.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2728_79481",
    x1: 906.749,
    y1: 628.967,
    x2: 986.287,
    y2: 637.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2728_79481",
    x1: 904.947,
    y1: 630.769,
    x2: 984.485,
    y2: 639.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2728_79481",
    x1: 903.146,
    y1: 632.57,
    x2: 982.683,
    y2: 641.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2728_79481",
    x1: 901.344,
    y1: 634.372,
    x2: 980.882,
    y2: 642.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2728_79481",
    x1: 899.274,
    y1: 635.528,
    x2: 978.812,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2728_79481",
    x1: 896.727,
    y1: 635.528,
    x2: 976.264,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2728_79481",
    x1: 894.178,
    y1: 635.528,
    x2: 973.716,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2728_79481",
    x1: 891.63,
    y1: 635.528,
    x2: 971.168,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2728_79481",
    x1: 889.082,
    y1: 635.528,
    x2: 968.62,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2728_79481",
    x1: 886.533,
    y1: 635.528,
    x2: 966.071,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2728_79481",
    x1: 883.984,
    y1: 635.528,
    x2: 963.522,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2728_79481",
    x1: 881.437,
    y1: 635.528,
    x2: 960.975,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2728_79481",
    x1: 878.889,
    y1: 635.528,
    x2: 958.426,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2728_79481",
    x1: 876.34,
    y1: 635.528,
    x2: 955.878,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2728_79481",
    x1: 873.793,
    y1: 635.528,
    x2: 953.331,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2728_79481",
    x1: 871.244,
    y1: 635.528,
    x2: 950.782,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2728_79481",
    x1: 868.695,
    y1: 635.528,
    x2: 948.233,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2728_79481",
    x1: 866.147,
    y1: 635.528,
    x2: 945.685,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2728_79481",
    x1: 863.6,
    y1: 635.528,
    x2: 943.137,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2728_79481",
    x1: 861.051,
    y1: 635.528,
    x2: 940.589,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2728_79481",
    x1: 858.503,
    y1: 635.528,
    x2: 938.041,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2728_79481",
    x1: 855.955,
    y1: 635.528,
    x2: 935.493,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2728_79481",
    x1: 853.406,
    y1: 635.528,
    x2: 932.944,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2728_79481",
    x1: 850.858,
    y1: 635.528,
    x2: 930.396,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2728_79481",
    x1: 848.311,
    y1: 635.528,
    x2: 927.848,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2728_79481",
    x1: 845.762,
    y1: 635.528,
    x2: 925.299,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2728_79481",
    x1: 843.214,
    y1: 635.528,
    x2: 922.752,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2728_79481",
    x1: 840.666,
    y1: 635.528,
    x2: 920.204,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2728_79481",
    x1: 838.117,
    y1: 635.528,
    x2: 917.655,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2728_79481",
    x1: 835.568,
    y1: 635.528,
    x2: 915.106,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2728_79481",
    x1: 833.021,
    y1: 635.528,
    x2: 912.559,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2728_79481",
    x1: 830.473,
    y1: 635.528,
    x2: 910.01,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2728_79481",
    x1: 827.924,
    y1: 635.528,
    x2: 907.462,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2728_79481",
    x1: 825.376,
    y1: 635.528,
    x2: 904.914,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2728_79481",
    x1: 822.828,
    y1: 635.528,
    x2: 902.366,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2728_79481",
    x1: 820.279,
    y1: 635.528,
    x2: 899.817,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2728_79481",
    x1: 817.731,
    y1: 635.528,
    x2: 897.269,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2728_79481",
    x1: 815.184,
    y1: 635.528,
    x2: 894.721,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2728_79481",
    x1: 812.635,
    y1: 635.528,
    x2: 892.173,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2728_79481",
    x1: 810.087,
    y1: 635.528,
    x2: 889.625,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2728_79481",
    x1: 807.539,
    y1: 635.528,
    x2: 887.077,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2728_79481",
    x1: 804.99,
    y1: 635.528,
    x2: 884.528,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2728_79481",
    x1: 802.442,
    y1: 635.528,
    x2: 881.98,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2728_79481",
    x1: 799.895,
    y1: 635.528,
    x2: 879.432,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2728_79481",
    x1: 797.346,
    y1: 635.528,
    x2: 876.883,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2728_79481",
    x1: 794.798,
    y1: 635.528,
    x2: 874.336,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2728_79481",
    x1: 792.25,
    y1: 635.528,
    x2: 871.788,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2728_79481",
    x1: 789.701,
    y1: 635.528,
    x2: 869.239,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2728_79481",
    x1: 787.152,
    y1: 635.528,
    x2: 866.69,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2728_79481",
    x1: 784.605,
    y1: 635.528,
    x2: 864.143,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2728_79481",
    x1: 782.057,
    y1: 635.528,
    x2: 861.594,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2728_79481",
    x1: 779.508,
    y1: 635.528,
    x2: 859.046,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2728_79481",
    x1: 776.96,
    y1: 635.528,
    x2: 856.498,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2728_79481",
    x1: 774.412,
    y1: 635.528,
    x2: 853.95,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2728_79481",
    x1: 771.863,
    y1: 635.528,
    x2: 851.401,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2728_79481",
    x1: 769.315,
    y1: 635.528,
    x2: 848.853,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_2728_79481",
    x1: 766.768,
    y1: 635.528,
    x2: 846.305,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2728_79481",
    x1: 764.219,
    y1: 635.528,
    x2: 843.757,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_2728_79481",
    x1: 761.671,
    y1: 635.528,
    x2: 841.209,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_2728_79481",
    x1: 759.123,
    y1: 635.528,
    x2: 838.661,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_2728_79481",
    x1: 756.574,
    y1: 635.528,
    x2: 836.112,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_2728_79481",
    x1: 754.026,
    y1: 635.528,
    x2: 833.564,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_2728_79481",
    x1: 751.479,
    y1: 635.528,
    x2: 831.016,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_2728_79481",
    x1: 748.93,
    y1: 635.528,
    x2: 828.467,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_2728_79481",
    x1: 746.382,
    y1: 635.528,
    x2: 825.92,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_2728_79481",
    x1: 743.834,
    y1: 635.528,
    x2: 823.372,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_2728_79481",
    x1: 741.285,
    y1: 635.528,
    x2: 820.823,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_2728_79481",
    x1: 738.736,
    y1: 635.528,
    x2: 818.274,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_2728_79481",
    x1: 736.189,
    y1: 635.528,
    x2: 815.727,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_2728_79481",
    x1: 733.641,
    y1: 635.528,
    x2: 813.178,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_2728_79481",
    x1: 731.092,
    y1: 635.528,
    x2: 810.63,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_2728_79481",
    x1: 728.544,
    y1: 635.528,
    x2: 808.082,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_2728_79481",
    x1: 725.996,
    y1: 635.528,
    x2: 805.534,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_2728_79481",
    x1: 723.447,
    y1: 635.528,
    x2: 802.985,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_2728_79481",
    x1: 720.899,
    y1: 635.528,
    x2: 800.437,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_2728_79481",
    x1: 718.352,
    y1: 635.528,
    x2: 797.889,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_2728_79481",
    x1: 715.803,
    y1: 635.528,
    x2: 795.341,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_2728_79481",
    x1: 713.255,
    y1: 635.528,
    x2: 792.793,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_2728_79481",
    x1: 710.707,
    y1: 635.528,
    x2: 790.245,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_2728_79481",
    x1: 708.158,
    y1: 635.528,
    x2: 787.696,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_2728_79481",
    x1: 705.61,
    y1: 635.528,
    x2: 785.148,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_2728_79481",
    x1: 703.062,
    y1: 635.528,
    x2: 782.6,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_2728_79481",
    x1: 700.514,
    y1: 635.528,
    x2: 780.051,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_2728_79481",
    x1: 697.965,
    y1: 635.528,
    x2: 777.503,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_2728_79481",
    x1: 695.418,
    y1: 635.528,
    x2: 774.956,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_2728_79481",
    x1: 692.869,
    y1: 635.528,
    x2: 772.407,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_2728_79481",
    x1: 690.32,
    y1: 635.528,
    x2: 769.858,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_2728_79481",
    x1: 687.773,
    y1: 635.528,
    x2: 767.311,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_2728_79481",
    x1: 685.225,
    y1: 635.528,
    x2: 764.762,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_2728_79481",
    x1: 682.676,
    y1: 635.528,
    x2: 762.214,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_2728_79481",
    x1: 680.128,
    y1: 635.528,
    x2: 759.666,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_2728_79481",
    x1: 677.58,
    y1: 635.528,
    x2: 757.118,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_2728_79481",
    x1: 675.031,
    y1: 635.528,
    x2: 754.569,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_2728_79481",
    x1: 672.483,
    y1: 635.528,
    x2: 752.021,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_2728_79481",
    x1: 669.936,
    y1: 635.528,
    x2: 749.473,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_2728_79481",
    x1: 667.387,
    y1: 635.528,
    x2: 746.924,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_2728_79481",
    x1: 664.839,
    y1: 635.528,
    x2: 744.377,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_2728_79481",
    x1: 662.291,
    y1: 635.528,
    x2: 741.829,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_2728_79481",
    x1: 659.742,
    y1: 635.528,
    x2: 739.28,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_2728_79481",
    x1: 657.194,
    y1: 635.528,
    x2: 736.732,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_2728_79481",
    x1: 654.646,
    y1: 635.528,
    x2: 734.184,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_2728_79481",
    x1: 652.098,
    y1: 635.528,
    x2: 731.635,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_2728_79481",
    x1: 649.549,
    y1: 635.528,
    x2: 729.087,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_2728_79481",
    x1: 647.002,
    y1: 635.528,
    x2: 726.54,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_2728_79481",
    x1: 644.453,
    y1: 635.528,
    x2: 723.991,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_2728_79481",
    x1: 641.904,
    y1: 635.528,
    x2: 721.442,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_2728_79481",
    x1: 639.356,
    y1: 635.528,
    x2: 718.894,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_2728_79481",
    x1: 636.809,
    y1: 635.528,
    x2: 716.346,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_2728_79481",
    x1: 634.26,
    y1: 635.528,
    x2: 713.798,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_2728_79481",
    x1: 631.712,
    y1: 635.528,
    x2: 711.25,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_2728_79481",
    x1: 629.164,
    y1: 635.528,
    x2: 708.702,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_2728_79481",
    x1: 626.615,
    y1: 635.528,
    x2: 706.153,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_2728_79481",
    x1: 624.067,
    y1: 635.528,
    x2: 703.605,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_2728_79481",
    x1: 621.52,
    y1: 635.528,
    x2: 701.057,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_2728_79481",
    x1: 618.971,
    y1: 635.528,
    x2: 698.508,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_2728_79481",
    x1: 616.423,
    y1: 635.528,
    x2: 695.961,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_2728_79481",
    x1: 613.875,
    y1: 635.528,
    x2: 693.413,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_2728_79481",
    x1: 611.326,
    y1: 635.528,
    x2: 690.864,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_2728_79481",
    x1: 608.778,
    y1: 635.528,
    x2: 688.316,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_2728_79481",
    x1: 606.23,
    y1: 635.528,
    x2: 685.768,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_2728_79481",
    x1: 603.682,
    y1: 635.528,
    x2: 683.219,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_2728_79481",
    x1: 601.133,
    y1: 635.528,
    x2: 680.671,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_2728_79481",
    x1: 598.586,
    y1: 635.528,
    x2: 678.124,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_2728_79481",
    x1: 596.037,
    y1: 635.528,
    x2: 675.575,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_2728_79481",
    x1: 593.488,
    y1: 635.528,
    x2: 673.026,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_2728_79481",
    x1: 590.94,
    y1: 635.528,
    x2: 670.478,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_2728_79481",
    x1: 588.393,
    y1: 635.528,
    x2: 667.93,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_2728_79481",
    x1: 585.844,
    y1: 635.528,
    x2: 665.382,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_2728_79481",
    x1: 583.296,
    y1: 635.528,
    x2: 662.834,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_2728_79481",
    x1: 580.748,
    y1: 635.528,
    x2: 660.286,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_2728_79481",
    x1: 578.199,
    y1: 635.528,
    x2: 657.737,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_2728_79481",
    x1: 575.651,
    y1: 635.528,
    x2: 655.189,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_2728_79481",
    x1: 573.104,
    y1: 635.528,
    x2: 652.641,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_2728_79481",
    x1: 570.555,
    y1: 635.528,
    x2: 650.092,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_2728_79481",
    x1: 568.007,
    y1: 635.528,
    x2: 647.545,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_2728_79481",
    x1: 565.459,
    y1: 635.528,
    x2: 644.997,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_2728_79481",
    x1: 562.91,
    y1: 635.528,
    x2: 642.448,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_2728_79481",
    x1: 560.362,
    y1: 635.528,
    x2: 639.9,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_2728_79481",
    x1: 557.814,
    y1: 635.528,
    x2: 637.352,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_2728_79481",
    x1: 555.266,
    y1: 635.528,
    x2: 634.803,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_2728_79481",
    x1: 552.717,
    y1: 635.528,
    x2: 632.255,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_2728_79481",
    x1: 550.17,
    y1: 635.528,
    x2: 629.708,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_2728_79481",
    x1: 547.621,
    y1: 635.528,
    x2: 627.159,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_2728_79481",
    x1: 545.072,
    y1: 635.528,
    x2: 624.61,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_2728_79481",
    x1: 542.524,
    y1: 635.528,
    x2: 622.062,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_2728_79481",
    x1: 539.977,
    y1: 635.528,
    x2: 619.514,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_2728_79481",
    x1: 537.428,
    y1: 635.528,
    x2: 616.966,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_2728_79481",
    x1: 534.88,
    y1: 635.528,
    x2: 614.418,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_2728_79481",
    x1: 532.332,
    y1: 635.528,
    x2: 611.87,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_2728_79481",
    x1: 529.783,
    y1: 635.528,
    x2: 609.321,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_2728_79481",
    x1: 527.235,
    y1: 635.528,
    x2: 606.773,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_2728_79481",
    x1: 524.687,
    y1: 635.528,
    x2: 604.225,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_2728_79481",
    x1: 522.139,
    y1: 635.528,
    x2: 601.676,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_2728_79481",
    x1: 519.591,
    y1: 635.528,
    x2: 599.129,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_2728_79481",
    x1: 517.043,
    y1: 635.528,
    x2: 596.581,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_2728_79481",
    x1: 514.494,
    y1: 635.528,
    x2: 594.032,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_2728_79481",
    x1: 511.945,
    y1: 635.528,
    x2: 591.483,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_2728_79481",
    x1: 509.398,
    y1: 635.528,
    x2: 588.936,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_2728_79481",
    x1: 506.85,
    y1: 635.528,
    x2: 586.387,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_2728_79481",
    x1: 504.301,
    y1: 635.528,
    x2: 583.839,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_2728_79481",
    x1: 501.754,
    y1: 635.528,
    x2: 581.292,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_2728_79481",
    x1: 499.205,
    y1: 635.528,
    x2: 578.743,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_2728_79481",
    x1: 496.656,
    y1: 635.528,
    x2: 576.194,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_2728_79481",
    x1: 494.108,
    y1: 635.528,
    x2: 573.646,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_2728_79481",
    x1: 491.561,
    y1: 635.528,
    x2: 571.098,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_2728_79481",
    x1: 489.012,
    y1: 635.528,
    x2: 568.549,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_2728_79481",
    x1: 486.464,
    y1: 635.528,
    x2: 566.002,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_2728_79481",
    x1: 483.916,
    y1: 635.528,
    x2: 563.454,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_2728_79481",
    x1: 481.367,
    y1: 635.528,
    x2: 560.905,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_2728_79481",
    x1: 478.819,
    y1: 635.528,
    x2: 558.357,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_2728_79481",
    x1: 476.271,
    y1: 635.528,
    x2: 555.809,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_2728_79481",
    x1: 473.723,
    y1: 635.528,
    x2: 553.26,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_2728_79481",
    x1: 471.175,
    y1: 635.528,
    x2: 550.713,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_2728_79481",
    x1: 468.627,
    y1: 635.528,
    x2: 548.165,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_2728_79481",
    x1: 466.078,
    y1: 635.528,
    x2: 545.616,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_2728_79481",
    x1: 463.529,
    y1: 635.528,
    x2: 543.067,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_2728_79481",
    x1: 460.982,
    y1: 635.528,
    x2: 540.52,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_2728_79481",
    x1: 458.434,
    y1: 635.528,
    x2: 537.971,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_2728_79481",
    x1: 455.885,
    y1: 635.528,
    x2: 535.423,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_2728_79481",
    x1: 453.337,
    y1: 635.528,
    x2: 532.875,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_2728_79481",
    x1: 450.789,
    y1: 635.528,
    x2: 530.327,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_2728_79481",
    x1: 448.24,
    y1: 635.528,
    x2: 527.778,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_2728_79481",
    x1: 445.692,
    y1: 635.528,
    x2: 525.23,
    y2: 644.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_2728_79481",
    x1: 444.361,
    y1: 637.398,
    x2: 523.899,
    y2: 645.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_2728_79481",
    x1: 443.331,
    y1: 639.728,
    x2: 522.869,
    y2: 648.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_2728_79481",
    x1: 442.301,
    y1: 642.059,
    x2: 521.839,
    y2: 650.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_2728_79481",
    x1: 441.271,
    y1: 644.389,
    x2: 520.808,
    y2: 652.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_2728_79481",
    x1: 440.24,
    y1: 646.72,
    x2: 519.778,
    y2: 655.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_2728_79481",
    x1: 439.21,
    y1: 649.051,
    x2: 518.748,
    y2: 657.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_2728_79481",
    x1: 438.18,
    y1: 651.381,
    x2: 517.717,
    y2: 659.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_2728_79481",
    x1: 437.15,
    y1: 653.712,
    x2: 516.688,
    y2: 662.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_2728_79481",
    x1: 436.119,
    y1: 656.042,
    x2: 515.657,
    y2: 664.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_2728_79481",
    x1: 435.09,
    y1: 658.373,
    x2: 514.628,
    y2: 666.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_2728_79481",
    x1: 434.059,
    y1: 660.704,
    x2: 513.596,
    y2: 669.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_2728_79481",
    x1: 433.029,
    y1: 663.034,
    x2: 512.567,
    y2: 671.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_2728_79481",
    x1: 431.998,
    y1: 665.365,
    x2: 511.536,
    y2: 673.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_2728_79481",
    x1: 430.969,
    y1: 667.695,
    x2: 510.507,
    y2: 676.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_2728_79481",
    x1: 429.937,
    y1: 670.027,
    x2: 509.475,
    y2: 678.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_2728_79481",
    x1: 428.908,
    y1: 672.358,
    x2: 508.446,
    y2: 680.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_2728_79481",
    x1: 427.877,
    y1: 674.688,
    x2: 507.415,
    y2: 683.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_2728_79481",
    x1: 426.848,
    y1: 677.019,
    x2: 506.385,
    y2: 685.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_2728_79481",
    x1: 425.816,
    y1: 679.349,
    x2: 505.354,
    y2: 687.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_2728_79481",
    x1: 424.787,
    y1: 681.68,
    x2: 504.325,
    y2: 690.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_2728_79481",
    x1: 423.756,
    y1: 684.011,
    x2: 503.294,
    y2: 692.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_2728_79481",
    x1: 422.727,
    y1: 686.341,
    x2: 502.264,
    y2: 694.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_2728_79481",
    x1: 421.695,
    y1: 688.672,
    x2: 501.233,
    y2: 697.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_2728_79481",
    x1: 420.666,
    y1: 691.002,
    x2: 500.204,
    y2: 699.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_2728_79481",
    x1: 419.636,
    y1: 693.333,
    x2: 499.174,
    y2: 701.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_2728_79481",
    x1: 418.605,
    y1: 695.664,
    x2: 498.143,
    y2: 704.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_2728_79481",
    x1: 417.575,
    y1: 697.994,
    x2: 497.113,
    y2: 706.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_2728_79481",
    x1: 416.545,
    y1: 700.325,
    x2: 496.083,
    y2: 708.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_2728_79481",
    x1: 415.515,
    y1: 702.655,
    x2: 495.052,
    y2: 711.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_2728_79481",
    x1: 414.484,
    y1: 704.986,
    x2: 494.022,
    y2: 713.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_2728_79481",
    x1: 413.454,
    y1: 707.318,
    x2: 492.992,
    y2: 715.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_2728_79481",
    x1: 412.424,
    y1: 709.648,
    x2: 491.962,
    y2: 718.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_2728_79481",
    x1: 411.394,
    y1: 711.979,
    x2: 490.931,
    y2: 720.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_2728_79481",
    x1: 410.363,
    y1: 714.309,
    x2: 489.901,
    y2: 722.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_2728_79481",
    x1: 409.333,
    y1: 716.64,
    x2: 488.871,
    y2: 725.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_2728_79481",
    x1: 408.303,
    y1: 718.971,
    x2: 487.841,
    y2: 727.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_2728_79481",
    x1: 407.272,
    y1: 721.301,
    x2: 486.81,
    y2: 729.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_2728_79481",
    x1: 406.242,
    y1: 723.632,
    x2: 485.78,
    y2: 732.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_2728_79481",
    x1: 405.212,
    y1: 725.962,
    x2: 484.75,
    y2: 734.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_2728_79481",
    x1: 404.182,
    y1: 728.293,
    x2: 483.719,
    y2: 736.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_2728_79481",
    x1: 403.151,
    y1: 730.623,
    x2: 482.689,
    y2: 739.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_2728_79481",
    x1: 402.121,
    y1: 732.954,
    x2: 481.659,
    y2: 741.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_2728_79481",
    x1: 401.092,
    y1: 735.285,
    x2: 480.63,
    y2: 743.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_2728_79481",
    x1: 400.061,
    y1: 737.615,
    x2: 479.598,
    y2: 746.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_2728_79481",
    x1: 399.031,
    y1: 739.946,
    x2: 478.569,
    y2: 748.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_2728_79481",
    x1: 398,
    y1: 742.277,
    x2: 477.538,
    y2: 750.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_2728_79481",
    x1: 396.971,
    y1: 744.608,
    x2: 476.508,
    y2: 753.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_2728_79481",
    x1: 395.939,
    y1: 746.939,
    x2: 475.477,
    y2: 755.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_2728_79481",
    x1: 394.91,
    y1: 749.269,
    x2: 474.448,
    y2: 757.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_2728_79481",
    x1: 393.879,
    y1: 751.6,
    x2: 473.417,
    y2: 760.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_2728_79481",
    x1: 392.85,
    y1: 753.93,
    x2: 472.387,
    y2: 762.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_2728_79481",
    x1: 391.818,
    y1: 756.261,
    x2: 471.356,
    y2: 764.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_2728_79481",
    x1: 390.789,
    y1: 758.592,
    x2: 470.327,
    y2: 767.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_2728_79481",
    x1: 389.758,
    y1: 760.922,
    x2: 469.296,
    y2: 769.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_2728_79481",
    x1: 388.729,
    y1: 763.253,
    x2: 468.266,
    y2: 771.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_2728_79481",
    x1: 387.697,
    y1: 765.583,
    x2: 467.235,
    y2: 774.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_2728_79481",
    x1: 386.668,
    y1: 767.914,
    x2: 466.206,
    y2: 776.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_2728_79481",
    x1: 385.637,
    y1: 770.245,
    x2: 465.174,
    y2: 778.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_2728_79481",
    x1: 384.607,
    y1: 772.575,
    x2: 464.145,
    y2: 781.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_2728_79481",
    x1: 383.577,
    y1: 774.906,
    x2: 463.115,
    y2: 783.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_2728_79481",
    x1: 382.547,
    y1: 777.236,
    x2: 462.085,
    y2: 785.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_2728_79481",
    x1: 381.517,
    y1: 779.568,
    x2: 461.054,
    y2: 788.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_2728_79481",
    x1: 380.486,
    y1: 781.899,
    x2: 460.024,
    y2: 790.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_2728_79481",
    x1: 379.456,
    y1: 784.229,
    x2: 458.994,
    y2: 792.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_2728_79481",
    x1: 378.426,
    y1: 786.56,
    x2: 457.964,
    y2: 795.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_2728_79481",
    x1: 377.396,
    y1: 788.89,
    x2: 456.933,
    y2: 797.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_2728_79481",
    x1: 376.365,
    y1: 791.221,
    x2: 455.903,
    y2: 799.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_2728_79481",
    x1: 375.335,
    y1: 793.552,
    x2: 454.873,
    y2: 802.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_2728_79481",
    x1: 374.305,
    y1: 795.882,
    x2: 453.842,
    y2: 804.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_2728_79481",
    x1: 373.274,
    y1: 798.213,
    x2: 452.812,
    y2: 806.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_2728_79481",
    x1: 372.244,
    y1: 800.543,
    x2: 451.782,
    y2: 809.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_2728_79481",
    x1: 371.214,
    y1: 802.874,
    x2: 450.752,
    y2: 811.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_2728_79481",
    x1: 370.184,
    y1: 805.205,
    x2: 449.721,
    y2: 813.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_2728_79481",
    x1: 369.153,
    y1: 807.535,
    x2: 448.691,
    y2: 816.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_2728_79481",
    x1: 368.123,
    y1: 809.866,
    x2: 447.661,
    y2: 818.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_2728_79481",
    x1: 367.093,
    y1: 812.196,
    x2: 446.631,
    y2: 820.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_2728_79481",
    x1: 366.062,
    y1: 814.527,
    x2: 445.6,
    y2: 823.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_2728_79481",
    x1: 365.033,
    y1: 816.859,
    x2: 444.571,
    y2: 825.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_2728_79481",
    x1: 364.002,
    y1: 819.189,
    x2: 443.54,
    y2: 827.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_2728_79481",
    x1: 362.973,
    y1: 821.52,
    x2: 442.51,
    y2: 830.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_2728_79481",
    x1: 361.941,
    y1: 823.85,
    x2: 441.479,
    y2: 832.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_2728_79481",
    x1: 360.912,
    y1: 826.181,
    x2: 440.45,
    y2: 834.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_2728_79481",
    x1: 359.881,
    y1: 828.512,
    x2: 439.419,
    y2: 837.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_2728_79481",
    x1: 358.852,
    y1: 830.842,
    x2: 438.389,
    y2: 839.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_2728_79481",
    x1: 357.82,
    y1: 833.173,
    x2: 437.358,
    y2: 841.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_2728_79481",
    x1: 356.791,
    y1: 835.503,
    x2: 436.329,
    y2: 844.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_2728_79481",
    x1: 355.76,
    y1: 837.834,
    x2: 435.298,
    y2: 846.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_2728_79481",
    x1: 354.73,
    y1: 840.165,
    x2: 434.268,
    y2: 848.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_2728_79481",
    x1: 353.699,
    y1: 842.495,
    x2: 433.237,
    y2: 851.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_2728_79481",
    x1: 352.67,
    y1: 844.826,
    x2: 432.208,
    y2: 853.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_2728_79481",
    x1: 351.639,
    y1: 847.156,
    x2: 431.176,
    y2: 855.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_2728_79481",
    x1: 350.609,
    y1: 849.487,
    x2: 430.147,
    y2: 858.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_2728_79481",
    x1: 349.578,
    y1: 851.819,
    x2: 429.116,
    y2: 860.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_2728_79481",
    x1: 348.549,
    y1: 854.149,
    x2: 428.087,
    y2: 862.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_2728_79481",
    x1: 347.519,
    y1: 856.48,
    x2: 427.056,
    y2: 865.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_2728_79481",
    x1: 346.488,
    y1: 858.81,
    x2: 426.026,
    y2: 867.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_2728_79481",
    x1: 345.458,
    y1: 861.141,
    x2: 424.996,
    y2: 869.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_2728_79481",
    x1: 344.428,
    y1: 863.472,
    x2: 423.966,
    y2: 872.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_2728_79481",
    x1: 343.397,
    y1: 865.802,
    x2: 422.935,
    y2: 874.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_2728_79481",
    x1: 342.367,
    y1: 868.133,
    x2: 421.905,
    y2: 876.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_2728_79481",
    x1: 341.337,
    y1: 870.463,
    x2: 420.875,
    y2: 879.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_2728_79481",
    x1: 340.307,
    y1: 872.794,
    x2: 419.844,
    y2: 881.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_2728_79481",
    x1: 339.276,
    y1: 875.125,
    x2: 418.814,
    y2: 883.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_2728_79481",
    x1: 338.246,
    y1: 877.455,
    x2: 417.784,
    y2: 886.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_2728_79481",
    x1: 337.216,
    y1: 879.786,
    x2: 416.754,
    y2: 888.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_2728_79481",
    x1: 336.186,
    y1: 882.116,
    x2: 415.723,
    y2: 890.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_2728_79481",
    x1: 335.155,
    y1: 884.447,
    x2: 414.693,
    y2: 893.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_2728_79481",
    x1: 334.125,
    y1: 886.777,
    x2: 413.663,
    y2: 895.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_2728_79481",
    x1: 333.095,
    y1: 889.109,
    x2: 412.633,
    y2: 897.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_2728_79481",
    x1: 332.064,
    y1: 891.44,
    x2: 411.602,
    y2: 900.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_2728_79481",
    x1: 331.034,
    y1: 893.77,
    x2: 410.572,
    y2: 902.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_2728_79481",
    x1: 330.004,
    y1: 896.101,
    x2: 409.542,
    y2: 904.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_2728_79481",
    x1: 328.975,
    y1: 898.431,
    x2: 408.512,
    y2: 907.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_2728_79481",
    x1: 327.943,
    y1: 900.762,
    x2: 407.481,
    y2: 909.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_2728_79481",
    x1: 326.914,
    y1: 903.093,
    x2: 406.452,
    y2: 911.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_2728_79481",
    x1: 325.883,
    y1: 905.423,
    x2: 405.421,
    y2: 914.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_2728_79481",
    x1: 324.854,
    y1: 907.754,
    x2: 404.391,
    y2: 916.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_2728_79481",
    x1: 323.822,
    y1: 910.084,
    x2: 403.36,
    y2: 918.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_2728_79481",
    x1: 322.793,
    y1: 912.415,
    x2: 402.331,
    y2: 921.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_2728_79481",
    x1: 321.762,
    y1: 914.746,
    x2: 401.299,
    y2: 923.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_2728_79481",
    x1: 320.732,
    y1: 917.076,
    x2: 400.27,
    y2: 925.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_2728_79481",
    x1: 319.701,
    y1: 919.407,
    x2: 399.239,
    y2: 928.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_2728_79481",
    x1: 318.672,
    y1: 921.737,
    x2: 398.21,
    y2: 930.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_2728_79481",
    x1: 317.641,
    y1: 924.069,
    x2: 397.178,
    y2: 932.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_2728_79481",
    x1: 316.611,
    y1: 926.4,
    x2: 396.149,
    y2: 934.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_2728_79481",
    x1: 315.58,
    y1: 928.73,
    x2: 395.118,
    y2: 937.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_2728_79481",
    x1: 314.551,
    y1: 931.061,
    x2: 394.089,
    y2: 939.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_2728_79481",
    x1: 313.52,
    y1: 933.391,
    x2: 393.057,
    y2: 941.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_2728_79481",
    x1: 312.49,
    y1: 935.722,
    x2: 392.028,
    y2: 944.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_2728_79481",
    x1: 311.459,
    y1: 938.053,
    x2: 390.997,
    y2: 946.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_2728_79481",
    x1: 310.43,
    y1: 940.383,
    x2: 389.967,
    y2: 948.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_2728_79481",
    x1: 309.399,
    y1: 942.714,
    x2: 388.937,
    y2: 951.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_2728_79481",
    x1: 308.369,
    y1: 945.044,
    x2: 387.907,
    y2: 953.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_2728_79481",
    x1: 307.339,
    y1: 947.375,
    x2: 386.877,
    y2: 955.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_2728_79481",
    x1: 306.309,
    y1: 949.706,
    x2: 385.846,
    y2: 958.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_2728_79481",
    x1: 305.278,
    y1: 952.036,
    x2: 384.816,
    y2: 960.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_2728_79481",
    x1: 304.248,
    y1: 954.367,
    x2: 383.786,
    y2: 962.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_2728_79481",
    x1: 303.218,
    y1: 956.697,
    x2: 382.756,
    y2: 965.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_2728_79481",
    x1: 302.187,
    y1: 959.028,
    x2: 381.725,
    y2: 967.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/Bg1.7b82c7d9bd3b650d74229f0ac3aafbc9.svg";
export { ForwardRef as ReactComponent };